import LogoMobile from './LogoMobile.jsx';
import './LogoMobile.less';

export default LogoMobile;
